"use client"

import { jsx as d } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import { u as s, A as f } from "./Addreth-_1H8QZKW.js";
import { a as u, T as x } from "./Addreth-_1H8QZKW.js";
import "react-dom";
const c = e(function(r, o) {
  const t = s(r);
  return /* @__PURE__ */ d(
    f,
    {
      ref: o,
      address: r.address,
      config: t
    }
  );
});
export {
  c as Addreth,
  u as AddrethConfig,
  x as THEMES
};
//# sourceMappingURL=index-no-wagmi.js.map
